import React, { useEffect, useState } from 'react';
import Brand from './Brand';
import HeaderNav from './HeaderNav';
import { RichText } from './CompanyReport';
import { reportApi } from '../services/api';

const LABELS = { firstlook: 'First Look', deepdive: 'Deep Dive' };

const ProductPreviewPage = ({ user, onLogout, onOpenProfile }) => {
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');
  const [product, setProduct] = useState('firstlook');
  const [tabId, setTabId] = useState('');
  useEffect(() => {
    let active = true;
    reportApi.preview().then((result) => { if (active) setPreview(result); })
      .catch((err) => { if (active) setError(err.message); });
    return () => { active = false; };
  }, []);
  const products = Object.keys(preview?.products || {}).filter((id) => preview.products[id].tabs.length);
  const selectedProduct = products.includes(product) ? product : products[0];
  const page = preview?.products[selectedProduct];
  const tab = page?.tabs.find((item) => item.id === tabId) || page?.tabs[0];
  return (
    <div className="app-shell">
      <header className="topbar"><Brand href="/preview" /><HeaderNav user={user} onLogout={onLogout} onOpenProfile={onOpenProfile} /></header>
      <main className="workspace hub-workspace preview-workspace">
        <section className="workspace-intro">
          <div><p className="eyebrow">Explore before you join</p><h1>Real research. A closer look.</h1></div>
          <p className="intro-copy">Explore excerpts from our Free Tier featured company. No account required.</p>
        </section>
        <div className="preview-disclaimer" role="note"><strong>Preview excerpts.</strong> Each section shows only its opening sentences. Excerpts omit detail and qualifications; they are not the complete research or investment advice. Features available depend on your plan.</div>
        {error ? <div className="error-box" role="alert">Unable to load preview: {error}</div> : !preview ? <p role="status">Loading report excerpts...</p> : (
          <>
            <div className="preview-tabs" aria-label="Report products">
              {products.map((id) => <button key={id} type="button" aria-pressed={selectedProduct === id} onClick={() => { setProduct(id); setTabId(''); }}>{LABELS[id] || id}</button>)}
            </div>
            <article className="panel preview-product dd-report">
              <p className="eyebrow">{preview.ticker} / {LABELS[selectedProduct]} / Preview excerpt</p>
              <h2 className="dd-ticker">{page?.title || page?.company || preview.ticker}</h2>
              <div className="dd-metaline">
                {page?.header?.price && <span>Price: <b>{page.header.price}</b></span>}
                {page?.header?.mktcap && <span>Market cap: <b>{page.header.mktcap}</b></span>}
                {(page?.header?.as_of || page?.generated_at) && <span>Report as of: {page.header?.as_of || page.generated_at}</span>}
              </div>
              <div className="preview-tabs" aria-label="Research sections">
                {page?.tabs.map((item) => <button key={item.id} type="button" aria-pressed={tab?.id === item.id} onClick={() => setTabId(item.id)}>{item.label}</button>)}
              </div>
              {tab && <section aria-label={tab.label}>
                {tab.blocks.map((block, index) => block.type === 'heading'
                  ? <h3 key={index}>{block.text}</h3>
                  : block.type === 'prose'
                    ? <p key={index}><RichText text={block.paragraphs[0]} enableHover={false} /></p>
                    : <p className="preview-excerpt-end" key={index}><span aria-hidden="true">...</span> <small>Preview excerpt — <a href="/plans">explore plans for more research</a></small></p>)}
              </section>}
            </article>
          </>
        )}
        <section className="panel preview-next">
          <div><h2>Find your level of access.</h2><p>Compare Free and paid plans, research selections, and hub access.</p></div>
          <a className="primary-button" href="/plans">Compare plans</a>
          {!user && <a className="preview-signin" href="/login">Already have an account? Sign in</a>}
        </section>
      </main>
    </div>
  );
};

export default ProductPreviewPage;
